import React from 'react';
import {
  Flex,
  Heading,
  Container,
  Text,
  Icon,
  HStack,
  Link,
  useColorModeValue,
} from '@chakra-ui/react';
import { BsDiscord } from 'react-icons/bs';
import { SiGmail } from 'react-icons/si';
import { AiFillLinkedin } from 'react-icons/ai';
import AnimatedPage from './Other/AnimatedPage';


const ContactPage = () => {
  const colorModevalue = useColorModeValue('#ffffff', '#1b202c');
  const underlineColor = useColorModeValue('rgb(64,64,64,0.6)', 'rgb(255,255,255,0.6)' )

  return (
    <AnimatedPage>
    <Flex minH={'66vh'}  mt={'2rem'} direction={'column'} alignItems={'center'}>
      <Heading
        size={'2xl'}
        borderBottom={`1px solid ${underlineColor}`}
        pb={'15px'}
        pl={'16px'}
        mb={'20px'}
        w={'100%'}
      >
        Contact
      </Heading>
      <Container maxW={'100%'}>
        <Text fontSize={['md','md','lg','lg','lg','lg']}>
          For any buisnesss inquiry/question or even just to talk feel free to
          reach out for me in any of the options below
        </Text>
      </Container>
      <Flex alignItems={'center'} mt={'4rem'}>
        <HStack spacing={'50px'}>
          <Link as={'a'} href="mailto:lior.r.dev@gmail.com" target="_blank" isExternal>
            <Icon
              as={SiGmail}
              transition={'all 0.5s'}
              _hover={{ transform: 'scale(1.2)', fill: '#EA4335' }}
              boxSize={['12','16','20','20','20','20']}
            ></Icon>
          </Link>
          <Link as={'a'} href={'https://discord.gg/b9xBkqPKA6'} target="_blank"  isExternal>
            <Icon
              backgroundImage={`linear-gradient(${colorModevalue}, ${colorModevalue})`}
              backgroundSize={'70% 55%'}
              backgroundPosition={'center center'}
              backgroundRepeat={'no-repeat'}
              transition={'transform 0.5s'}
              _hover={{
                transform: 'scale(1.2)',
                fill: '#6069bf',
                backgroundImage: 'linear-gradient(#ffffff, #ffffff)',
              }}
              boxSize={['12','16','20','20','20','20']}
              as={BsDiscord}
            ></Icon>
          </Link>
          <Link as={'a'} href={'https://www.linkedin.com/in/liorreuven'} target="_blank"  isExternal>
            <Icon
              backgroundImage={`linear-gradient(${colorModevalue}, ${colorModevalue})`}
              backgroundSize={'70% 60%'}
              backgroundPosition={'center center'}
              backgroundRepeat={'no-repeat'}
              transition={'transform 0.5s'}
              _hover={{
                transform: 'scale(1.2)',
                backgroundImage: 'linear-gradient(#ffffff, #ffffff)',
                fill: '#0a66c2',
              }}
              boxSize={['12','16','20','20','20','20']}
              as={AiFillLinkedin}
            ></Icon>
          </Link>
        </HStack>
      </Flex>
    </Flex>
    </AnimatedPage>
  );
};

export default ContactPage;
